import React from 'react';
import { Skeleton } from 'site-modules/shared/components/skeleton/skeleton';

import './dealership-item-skeleton.scss';

export const DealershipItemSkeleton = () => (
  <div className="dealership-item-skeleton rounded-16 p-1 mb-1">
    <div className="w-80 d-inline-block">
      <Skeleton className="d-block height-22 rounded-6 w-40 mb-0_5" />
      <Skeleton className="d-block height-18 rounded-6 w-30 mb-0_25" />
      <Skeleton className="d-block height-18 rounded-6 w-70 mb-0_5" />
      <Skeleton className="d-block height-18 rounded-6 w-60" />
    </div>
    <div className="w-20 d-inline-block vertical-top text-end">
      <Skeleton className="rounded-8 icon-wrapper d-inline-block" />
    </div>
  </div>
);
